import { render } from "./AppInfo.vue?vue&type=template&id=081260bc"
import script from "./AppInfo.vue?vue&type=script&lang=js"
export * from "./AppInfo.vue?vue&type=script&lang=js"

import "./AppInfo.vue?vue&type=style&index=0&id=081260bc&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__